import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { option } from '../geolocationOption'

type GeoLocationState = {
  lat: number
  lon: number
  accuracy: number
  isLoaded: boolean
}

const useGeoLocation = () => {
  const { t } = useTranslation()
  const [geoLocation, setGeoLocation] = useState<GeoLocationState>({
    lat: 0,
    lon: 0,
    accuracy: 0,
    isLoaded: false,
  })

  const setGeoLocationFn = (coords: GeolocationCoordinates) => {
    setGeoLocation({
      lat: coords.latitude,
      lon: coords.longitude,
      accuracy: coords.accuracy,
      isLoaded: true,
    })
  }

  useEffect(() => {
    getGeolocation(t('spot.access_error_message_02', '位置情報の使用許可がおりませんでした。'))
      .then((coords) => {
        if (coords) {
          setGeoLocationFn(coords)
        } else {
          // 取得失敗・拒否の場合も isLoaded = true にして、ローディングを終了させる
          setGeoLocation((prev) => ({ ...prev, isLoaded: true }))
        }
      })
      .catch(() => {
        // パーミッション拒否などの例外も isLoaded = true にする
        setGeoLocation((prev) => ({ ...prev, isLoaded: true }))
      })
  }, [])

  return geoLocation
}

export const getGeolocation = (message: string): Promise<GeolocationCoordinates | null> => {
  if ('geolocation' in navigator) {
    return new Promise<GeolocationCoordinates>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          resolve(coords)
        },
        reject,
        option,
      )
    })
  } else {
    alert(message)
    return Promise.resolve(null)
  }
}

export default useGeoLocation
